import { authAxiosClient } from '@/lib';
import { withLogger } from '@/utils';
import { authAPIUrls } from '../data';
import { User } from '@/features/users';

type Param = {
  email: string;
  password: string;
};

// Response when 2FA is enabled
type TFAResponse = {
  preAuthToken: string;
  expiresAt: number;
};

// Response when 2FA is disabled
type TokenResponse = {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
};

type NoTFAResponse = {
  tokenResponse: TokenResponse;
  userInfo: User;
};

type ResponseData = TFAResponse | NoTFAResponse;

type Return = {
  message: string;
  data: ResponseData;
};

export const sendLogin = withLogger(async (param: Param): Promise<Return> => {
  const { data } = await authAxiosClient.post<Return>(
    authAPIUrls.login,
    param,
  );

  return data;
});
